module.exports = __webpack_public_path__ + "static/topic-2-6eea1d775f58c053ab288fe65f094982.jpg";